import Vue from 'vue';
import App from './App.vue';
import store from './store/main';
import router from './router/main';
import i18n from './locales/main';
import './style/main';
import './plugins/main';

import SignalRPlugin from '@/plugins/signalrPlugin'

Vue.config.productionTip = false;

// registrazione plugin
Vue.use(SignalRPlugin, {
    url:
        process.env.NODE_ENV !== 'production' ?
            '/signalr/hubs' // URL del tuo server SignalR
            :
            'http://gare.federbridge.it/WFigb/signalr/hubs' // URL del tuo server SignalR
})


new Vue({
    render: h => h(App),
    store: store,
    router: router,
    i18n: i18n,
}).$mount('#app');
